import { useNavigate } from "react-router-dom";
import { generateHotelUrl } from "../../utils/urlUtils";

const FeaturedHotelCard = ({ hotel, searchParams }) => {
  const navigate = useNavigate();
  
  // Check if this hotel has available rooms based on petRoomAssignments
  const hasAvailableRooms = hotel.petRoomAssignments && hotel.petRoomAssignments.length > 0;

  // Pet type acceptability
  const acceptsDogs = hotel.maxWeightByType?.Dog > 0;
  const acceptsCats = hotel.maxWeightByType?.Cat > 0;
  const acceptsExotic = hotel.maxWeightByType?.Exotic > 0;

  return (
    <div
      onClick={() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        // Use the SEO-friendly URL with slugs
        navigate(generateHotelUrl(hotel), {
          state: { hotel, searchParams },
        });
      }}
      className="w-full max-w-[400px] mx-auto transform transition-all duration-300 ease-in-out hover:scale-[1.02] hover:-translate-y-1"
    >
      <div className="relative rounded-lg overflow-hidden shadow-lg bg-white h-full flex flex-col">
        {/* Image container */}
        <div className="relative">
          <img 
            src={hotel.images && hotel.images.length > 0 ? hotel.images[0] : "/placeholder-hotel.jpg"} 
            alt={`${hotel.name} - Pet hotel in ${hotel.city}, ${hotel.location}`} 
            className="w-full h-48 object-cover"
          />
          
          {/* Availability indicator - top right like in the screenshot */}
          {!hasAvailableRooms && (
            <div className="absolute top-2 right-2 bg-red-500 text-white text-sm font-medium px-3 py-1 rounded-md">
              Not Available
            </div>
          )}
        </div>
        
        {/* Content container */}
        <div className="p-4 flex flex-col flex-grow">
          {/* Hotel name */}
          <h3 className="text-lg font-semibold text-gray-800 mb-1">
            {hotel.name}
          </h3>
          
          {/* Location */}
          <div className="flex items-center text-sm text-gray-600 mb-2">
            <span className="text-red-500 mr-1">📍</span>
            <span>
              {hotel.city}, {hotel.location}
            </span>
          </div>
          
          {/* Pet types - displayed vertically as requested */}
          <div className="flex flex-col mb-2">
            {acceptsDogs && (
              <div className="flex items-center text-sm text-gray-600">
                <span>🐶 Up to {hotel.maxWeightByType.Dog}kg</span>
              </div>
            )}
            
            {acceptsCats && (
              <div className="flex items-center text-sm text-gray-600">
                <span>🐱 Up to {hotel.maxWeightByType.Cat}kg</span>
              </div>
            )}
            
            {acceptsExotic && (
              <div className="flex items-center text-sm text-gray-600">
                <span>🦜 Up to {hotel.maxWeightByType.Exotic}kg</span>
              </div>
            )}
          </div>
          
          {/* Spacing to push the button to the bottom */}
          <div className="flex-grow"></div>
          
          {/* Action button - aligned to the right if available, otherwise centered */}
          <div className={`flex ${hasAvailableRooms ? 'justify-end' : 'justify-center'} mt-2`}>
            <button 
              className={`${hasAvailableRooms ? 'bg-green-500' : 'bg-blue-500'} text-white px-4 py-2 rounded-md text-sm font-medium`}
            >
              {hasAvailableRooms 
                ? (hotel.pricePerNight > 0 ? `MYR ${hotel.pricePerNight}` : "Available") 
                : "View Details"
              }
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedHotelCard;